import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { SupportContactFormState, AccountProperty } from '../types';

// Initial state for the Support Contact form
const initialState: SupportContactFormState = {
  contactPhone: '',
  contactEmail: '',
  contactPhoneID: undefined,
  contactEmailID: undefined,
  isSaving: false,
  accountProperties: {
    emailObject: null,
    contactNumberObject: null,
  },
};

// Create slice for Support Contact
export const supportContactSlice = createSlice({
  name: 'supportContact',
  initialState,
  reducers: {
    setContactPhone: (state, action: PayloadAction<string>) => {
      state.contactPhone = action.payload;
    },
    setContactEmail: (state, action: PayloadAction<string>) => {
      state.contactEmail = action.payload;
    },
    setContactIDs: (
      state,
      action: PayloadAction<{ phoneID: number; emailID: number }>,
    ) => {
      state.contactPhoneID = action.payload.phoneID;
      state.contactEmailID = action.payload.emailID;
    },
    setIsSaving: (state, action: PayloadAction<boolean>) => {
      state.isSaving = action.payload;
    },
    setAccountProperties: (
      state,
      action: PayloadAction<{
        emailObject: AccountProperty;
        contactNumberObject: AccountProperty;
      }>,
    ) => {
      state.accountProperties.emailObject = action.payload.emailObject;
      state.accountProperties.contactNumberObject =
        action.payload.contactNumberObject;
    },
    resetSupportContact: () => initialState, // Reset state to initial values
  },
});

// Export actions for use in dispatchers
export const { actions: supportContactActions } = supportContactSlice;

// Selectors

export const selectSupportContact = (state: RootState) => state.supportContact;

export const selectContactPhone = createSelector(
  selectSupportContact,
  state => state.contactPhone,
);

export const selectContactEmail = createSelector(
  selectSupportContact,
  state => state.contactEmail,
);

export const selectIsSaving = createSelector(
  selectSupportContact,
  state => state.isSaving,
);

export const selectAccountProperties = createSelector(
  selectSupportContact,
  state => state.accountProperties,
);

export default supportContactSlice.reducer;
